<template>
  <div>
    <div class="d-flex align-center mb-2">
      <back-btn class="mr-3" />
      <h3 class="title-page">{{ $t("warehouse") }} /</h3>
      <h4 class="ml-1 mb-2">{{ warehouseName }}</h4>
    </div>
    <div>
      <div class="admin_container">
        <div class="d-flex justify-lg-space-between warehouse_top_section">
          <custom-input-text
            class="user_input no-margin"
            style="max-width: 400px"
            :placeholder="$t('productName')"
            v-model="nameFilterProduct"
            @input="filterWarehouseProduct"
          />
          <v-btn
            color="primary"
            v-if="permissions.WAREHOUSE_CREATE"
            @click.stop
            :to="{
              name: 'reference-warehouse-edit',
              params: { id },
            }"
            >{{ $t("editWarehouse") }}</v-btn
          >
        </div>
        <v-divider class="my-4" />
        <div class="division_main">
          <warehouse-view-table
            stillage-route-name="warehouse-stillage-view"
            :data="boardData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackBtn from "@/components/ui/BackBtn";
import WarehouseViewTable from "@/components/warehouse/WarehouseViewTable";
import { debounce } from "@/utils/pureFunctions";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

export default {
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      nameFilterProduct: null,
      stillageDialog: false,
      permissions: {},
      boardData: {
        boards: [],
        columns: [],
        rows: [],
      },
      // boardData: {
      //   rows: [120, 120],
      //   columns: [120, 120, 120, 120],
      //   boards: [
      //     [
      //       {
      //         id: "73be0ce0-9a3e-4d9c-9095-2d32d967fcd3",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Stillage",
      //         columnId: "f7bcca3c-e417-47a0-a6a2-7155eb278359",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //         stillageColor: "NOT_CONFIGURED",
      //       },
      //       {
      //         id: "ecd2369a-93f5-4283-ae34-a1779c05b6fc",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Stillage",
      //         columnId: "f7bcca3c-e417-47a0-a6a2-7155eb278359",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //         stillageColor: "NOT_CONFIGURED",
      //       },
      //     ],
      //     [
      //       {
      //         id: "85a8aa5e-e019-4300-be1a-cfa66b428791",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Field",
      //         columnId: "f3c79fc3-f3a8-4f4a-b7c3-08b53217f5c0",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //       },
      //       {
      //         id: "e571f988-d5df-4ef2-8849-bc2ce862a7d0",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Stillage",
      //         columnId: "f3c79fc3-f3a8-4f4a-b7c3-08b53217f5c0",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //         stillageColor: "NOT_CONFIGURED",
      //       },
      //     ],
      //     [
      //       {
      //         id: "7cb8f8e1-37dd-4d6a-98e9-39011a277caf",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Field",
      //         columnId: "a0da480b-138e-4584-b5c2-cf901b9cf665",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //       },
      //       {
      //         id: "4a36f6c2-35e5-4108-a6d5-d201019910d5",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Field",
      //         columnId: "a0da480b-138e-4584-b5c2-cf901b9cf665",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //       },
      //     ],
      //     [
      //       {
      //         id: "e881561d-59a5-4377-8d20-be16a2d96134",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Corridor",
      //         columnId: "a6092f88-59b9-4c9c-894a-fabfac0207a6",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //       },
      //       {
      //         id: "8af836ae-ac87-4fbb-bc54-2ae94addccd7",
      //         width: "120.0",
      //         height: 120,
      //         placeType: "Corridor",
      //         columnId: "a6092f88-59b9-4c9c-894a-fabfac0207a6",
      //         full: false,
      //         hasProduct: false,
      //         alarm: false,
      //       },
      //     ],
      //   ],
      // },
      // TODO need to delete mock data boardData
      warehouseName: null,
    };
  },
  watch: {},
  components: {
    BackBtn,
    WarehouseViewTable,
  },
  methods: {
    filterWarehouseProduct: debounce(async function () {
      await this.getBoardData();
      await this.$router.replace({
        query: { productName: this.nameFilterProduct },
      });
    }, 300),
    async getNameWarehouses() {
      try {
        const {
          data: { data, permissions },
        } = await this.$http.get("warehouse/get-item/", {
          params: {
            id: this.id,
          },
        });
        this.permissions = permissions;
        this.warehouseName = data.name;
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
    async getBoardData() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("warehouse/board", {
          params: {
            id: this.id,
            term: this.nameFilterProduct,
          },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = boxService.parseData(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    if (this.$route.query.productName) {
      this.nameFilterProduct = this.$route.query.productName;
    }
    this.showLoading();
    await this.getBoardData();
    await this.getNameWarehouses();
    this.clearLoading();
  },
};
</script>

<style scoped>
.warehouse_top_section {
  gap: 10px;
}
@media screen and (max-width: 400px) {
  .warehouse_top_section {
    flex-direction: column !important;
    gap: 10px;
  }
}
</style>
